<template>
<div class="chapter">
<div class="inner_page">
<div class="copyrightPage" id="cop01">
<p class="copyrightText"><img alt="image" src="Images/crlogo.jpg"/><br/>
SIMON &amp; SCHUSTER BOOKS FOR YOUNG READERS<br/>
An imprint of Simon &amp; Schuster Children’s Publishing Division <br/>1230 Avenue of the Americas, New York, New York 10020</p>
<p class="copyrightText">This book is a work of fiction. Any references to historical events, real people, or real locales are used fictitiously. Other names, characters, places, and incidents are products of the author’s imagination, and any resemblance to actual events or locales or persons, living or dead, is entirely coincidental.</p>
<p class="copyrightText">Copyright © 2009 by Alex Sanchez</p>
<p class="copyrightText">All rights reserved, including the right of reproduction in whole or in part in any form.</p>
<p class="copyrightText">S<span class="smallCaps">IMON</span> &amp; S<span class="smallCaps">CHUSTER</span> B<span class="smallCaps">OOKS FOR</span> Y<span class="smallCaps">OUNG</span> R<span class="smallCaps">EADERS</span> is a trademark of Simon &amp; Schuster, Inc.</p>
<p class="copyrightText">Library of Congress Cataloging-in-Publication Data Sanchez, Alex, 1957-<br/>
Bait/Alex Sanchez.—1st ed.<br/>
p. cm.</p>
<p class="copyrightText">Summary: Diego keeps getting into trouble because of his explosive temper until he finally finds a probation officer who helps him get to the root of his anger so that he can stop running from his past.</p>
<p class="copyrightText">ISBN-13: 978-1-4169-9505-0<br/>
ISBN-10: 1-4169-9505-6</p>
<p class="copyrightText">[1. Emotional problems—Fiction. 2. Sexual abuse victims-—Fiction. 3. Stepfathers—Fiction. 4. Mexican Americans—Fiction.] I. Title.<br/>
PZ7.S19475Bai 2009<br/>
[Fic]—dc22<br/>
2008038815</p>
<p class="copyrightText">Visit us on the Web: <br/>
<span class="xrefURL"><a href="http://www.SimonandSchuster.com" target="_blank">http://www.SimonandSchuster.com</a></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416995050_cop01.vue?06c711d6